const getDisplayName = (
  username: string | undefined,
  prefix: string | undefined,
): string => {
  return username?.replace(prefix || '', '') || '';
};

export default getDisplayName;
